'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackPageLoad = exports.TrackClick = exports.initializeTracking = undefined;
exports.trackPage = trackPage;
exports.trackEvent = trackEvent;
exports.trackLead = trackLead;
exports.trackModalImpression = trackModalImpression;

var _super_properties = require('./super_properties');

var _super_properties2 = _interopRequireDefault(_super_properties);

var _queue = require('./queue');

var _queue2 = _interopRequireDefault(_queue);

var _lead_helper = require('./lead_helper');

var _lead_helper2 = _interopRequireDefault(_lead_helper);

var _helper = require('./helper');

var _helper2 = _interopRequireDefault(_helper);

var _InitializeTracking = require('./InitializeTracking.js');

var _InitializeTracking2 = _interopRequireDefault(_InitializeTracking);

var _TrackClick = require('./TrackClick.js');

var _TrackClick2 = _interopRequireDefault(_TrackClick);

var _TrackPageLoad = require('./TrackPageLoad.js');

var _TrackPageLoad2 = _interopRequireDefault(_TrackPageLoad);

var _validate = require('./validate.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global MOVEAnalytics */
(0, _queue2.default)();

function trackPage(pageName, props, _integrations) {
  (0, _validate.validatePageName)(pageName);
  try {
    var properties = Object.assign({}, props, (0, _super_properties2.default)());
    MOVEAnalytics.trackPage(pageName, properties, _integrations);
  } catch (e) {
    console.log(e);
  }
}

function trackEvent(eventName, props, _integrations) {
  var _sendEventOnNextPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  try {
    var properties = Object.assign({}, (0, _super_properties2.default)(), props);
    MOVEAnalytics.trackEvent(eventName, properties, _integrations, _sendEventOnNextPage);
  } catch (e) {
    console.log(e);
  }
}

/* trackLead is a helper function used by RDC-BASECAMP.
   In RDC-X, we keep the lead tracking logic there, and directly call trackEvent.
   I would recommend NOT using this below function, but please keep it in tact for basecamp usage.
*/
// eslint-disable-next-line complexity
function trackLead(props, opts) {
  var propertyStatus = opts.isBdp ? 'for_sale' : opts.propertyStatus;
  var listingLeadDelivery = _lead_helper2.default.getLeadDelivery(propertyStatus, opts) || '';
  var dataSourceType = _lead_helper2.default.getDataSourceType(opts.flags, opts.source);
  var placement = _helper2.default.buildPlacement(opts.placementData);
  var eventToTrack = void 0;

  switch (propertyStatus) {
    case 'new_plan':
    case 'new_community':
    case 'for_sale':
      if (opts.leadFlow === 'mal') {
        props.forSaleLeads = 'web:leads:' + propertyStatus + ':' + listingLeadDelivery + ':mal:' + placement;
      } else {
        props.forSaleLeads = 'web:leads:' + propertyStatus + ':' + listingLeadDelivery + ':' + placement;
      }
      if (listingLeadDelivery === 'showcase' || listingLeadDelivery.includes('advantage_pro')) {
        eventToTrack = 'advantageLead';
      } else if (listingLeadDelivery === 'cobroke' || listingLeadDelivery === 'co_broke') {
        eventToTrack = 'cobrokeLead';
      }

      break;
    case 'not_for_sale':
      props.notForSaleLeads = 'web:leads:not_for_sale:' + listingLeadDelivery + ':' + placement;
      eventToTrack = 'notForSaleLead';
      break;
    case 'for_rent':
      props.rentalLeads = 'web:leads:for_rent:' + (dataSourceType || '') + ':' + listingLeadDelivery + ':' + placement;
      if (listingLeadDelivery === 'basic') {
        if (opts.leadMethod === 'call') {
          eventToTrack = 'rentalBasicPhoneLead';
        } else {
          eventToTrack = 'rentalBasicLead';
        }
      } else if (listingLeadDelivery === 'showcase' || listingLeadDelivery === 'advantage_pro') {
        eventToTrack = 'rentalShowcaseLead';
      }
      break;
    default:
      console.warn('Warning: "' + propertyStatus + '" is an unrecognized propertyStatus value');
  }

  var isPropertyForRent = propertyStatus === 'for_rent';
  var isOpcityRentalLead = isPropertyForRent && opts.flags && opts.flags.is_flip_market_enabled;
  var opcityRentalData = isOpcityRentalLead ? 'opcity_rental_lead' : isPropertyForRent ? 'unknown' : undefined;
  var additionalData = {
    channel: _lead_helper2.default.getChannel(opts.propertyStatus),
    leadDelivery: listingLeadDelivery,
    leadEnhancements: _lead_helper2.default.getLeadEnhancements(opts.leadType, opts.showContactALender, opts.isLcmEnabled) || opts.leadAdditions,
    leadPlacement: placement,
    leadAttributes: opts.leadAdditions === 'military' ? 'veterans_lead' : '',
    leadFlow: opts.leadFlow,
    opcityRental: opcityRentalData
  };

  trackEvent(eventToTrack, Object.assign({}, props, additionalData));
}

function trackModalImpression(modalName, placementData) {
  var modalTrigger = _helper2.default.buildPlacement(placementData);
  var modalData = {
    modalName: modalName,
    modalTrigger: modalTrigger
  };
  trackEvent('modalImpression', modalData);
}

exports.default = {
  trackPage: trackPage,
  trackEvent: trackEvent,
  trackLead: trackLead,
  trackModalImpression: trackModalImpression
};
exports.initializeTracking = _InitializeTracking2.default;
exports.TrackClick = _TrackClick2.default;
exports.TrackPageLoad = _TrackPageLoad2.default;


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/source-map-loader!/data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/index.js
// module id = 1101
// module chunks = 48 49 50